import { render } from "./UserCalendar.vue?vue&type=template&id=8169f8c6&scoped=true"
import script from "./UserCalendar.vue?vue&type=script&lang=js"
export * from "./UserCalendar.vue?vue&type=script&lang=js"

import "./UserCalendar.vue?vue&type=style&index=0&id=8169f8c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8169f8c6"]])

export default __exports__